import createPersistedState from "./create-persisted-state"
import createLogger from "vuex/dist/logger"
import { isProduction } from "@/consts"

const plugins = [createPersistedState]

if (!isProduction) {
    plugins.push(createLogger())
}

export default plugins
